<template>
    <div class="user_all" v-loading="fullscreenLoading">
        <div class="user_search">
            <!-- <span style="width: 100px;display: inline-block">RPC服务：</span>
            <el-select
                    style="width: 250px"
                    v-model="selectRpc"
                    @change="changeRpc()"
                    placeholder="RPC服务"
            >
                <el-option
                        v-for="item in optionRpc"
                        :key="item.rpcUrl"
                        :label="item.rpcUrl"
                        :value="item.rpcUrl"
                ></el-option>
            </el-select> -->
            <span style="width: 100px;display: inline-block">{{ $t('title.sig_type') }}：</span>
            <el-select
                    style="width: 250px"
                    v-model="selectSigType"
                    @change="changeSigType()"
                    :placeholder="$t('title.Select_sig_type')"
            >
                <el-option
                        v-for="item in createSigType"
                        :key="item.type"
                        :label="item.label"
                        :value="item.type"
                ></el-option>
            </el-select>
            <span style="width: 100px;display: inline-block"></span>
            <el-select
                    style="width: 250px"
                    v-model="selectChain"
                    @change="changeChain()"
                   :placeholder="$t('title.Please_select_the_chain')"
            >
                <el-option
                        v-for="item in optionsChain"
                        :key="item"
                        :label="item+$t('title.chain')"
                        :value="item"
                ></el-option>
            </el-select>
            <!--            <el-button type="primary" style="margin-left: 5%" @click="searchRpc()" :loading=isResponse>查询</el-button>-->
        </div>
        <div class="user_search">
            <span style="width: 100px;display: inline-block">From：</span>
            <el-select
                    style="width: 250px"
                    v-model="selectUserA"
                    @change="changeUserA()"
                    :placeholder="this.$t('title.please_choose')"
            >
                <el-option
                        v-for="item in userA"
                        :key="item.id"
                        :label="`${item.nickname} - ${item.address}`"
                        :value="item.id"
                ></el-option>
            </el-select>

            <span style="width: 70px;display: inline-block;margin-left: 30px">To：</span>

            <el-select
                    style="width: 250px"
                    v-model="selectUserB"
                    @change="changeUserB()"
                    :placeholder="this.$t('title.please_choose')"
            >
                <el-option
                        v-for="item in userB"
                        :key="item.id"
                        :label="`${item.nickname} - ${item.address}`"
                        :value="item.id"
                ></el-option>
            </el-select>
        </div>
        <div class="user_search">

            <span style="width: 100px;display: inline-block;">{{ $t('title.Transaction_amount') }}：</span>
            <el-input type="primary" style="width: 250px" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入交易数额"
                      v-model="sendValue">

            </el-input>
        </div>
        <div class="user_search" v-show="selectSigType == '2'">
            <span style="width: 100px;display: inline-block;">{{ $t('title.Contract_address') }}：</span>

            <el-select
                    style="width: 250px"
                    v-model="selectContract"
                    @change="changeContract()"
                    :placeholder="this.$t('title.Please_select_contract_address')"
            >
                <el-option
                        v-for="item in contractList"
                        :key="item.id"
                        :label="item.contractAddress"
                        :value="item.contractAddress"
                ></el-option>
            </el-select>
        </div>
        <div class="user_search">
            <el-button type="primary" style="height: 40px" @click="createSigs()" :loading=isResponse>
            {{ $t('title.Generate_sig') }}
            </el-button>
        </div>


        <div class="user_search" style="display: flex">
            <el-button type="primary" style="height: 40px" @click="sendMsg()" :loading=isResponse>
               {{ $t('title.Send_sig_transaction') }}
            </el-button>

        </div>
        <div class="layout">
            <div class="setting">
                <ul>
                    <li>
                        <label>{{ $t('title.theme') }}</label>
                        <select v-model="theme">
                            <option value="">{{ this.$t('title.default') }}</option>
                            <option value="one-dark">one-dark</option>
                            <option value="vs-code">vs-code</option>
                        </select>
                    </li>
                    <li>
                        <label>{{ $t('title.Collapse_all') }}</label>
                        <select v-model="closed">
                            <option :value="false">false</option>
                            <option :value="true">true</option>
                        </select>
                    </li>

                    <li>
                        <label>deep</label>
                        <select v-model="deep">
                            <option v-for="item in 10" :value="item">{{item}}</option>
                        </select>
                    </li>
                    <li>
                        <label>font-size</label>
                        <select v-model="fontSize">
                            <option v-for="item in 10" :value="item+11">{{item+11}}</option>
                        </select>
                    </li>
                    <li>
                        <label for="line-height">line-height</label>
                        <select v-model="lineHeight">
                            <option v-for="item in 20" :value="item*2+14">{{item*2+14}}</option>
                        </select>
                    </li>

                </ul>
            </div>
        </div>
        <div class="content">
            <json-view :data="json" :theme="theme" :deep="deep" :iconStyle="iconStyle" :fontSize="fontSize"
                       :lineHeight="lineHeight" :closed="closed" :iconColor="iconColor"/>
        </div>
        <div class="con_table">
            <el-table
                    :data="tableData"
                    height="520"
                    border
                    style="width: 100%;margin-bottom: 30px;margin-top: 40px"
                    :header-cell-style="this.tableHeaderColor"
            >
                <el-table-column
                        :label="this.$t('title.Serial_number')"
                        fixed
                        align="center"
                        width="90">
                    <template slot-scope="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.RPC_service')"
                        width="200"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.rpcServer}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Chain_id')"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromChainId}}</span>
                    </template>
                </el-table-column>
                <!--                <el-table-column-->
                <!--                        label="转账方名称"-->
                <!--                        align="center">-->
                <!--                    <template slot-scope="scope">-->
                <!--                        <span>{{scope.row.fromAddress}}</span>-->

                <!--                    </template>-->
                <!--                </el-table-column>-->
                <el-table-column
                        :label="this.$t('title.Transfer_address')"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromAddress}}</span>
                        <br>
                        <span>{{to_32_decimal(scope.row.fromAddress)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Amount_before_transfer')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromBeforeCoins}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                       :label="this.$t('title.Amount_after_transfer')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromAfterCoins}}</span>
                    </template>
                </el-table-column>
                <!--                <el-table-column-->
                <!--                        label="收款方名称"-->
                <!--                        align="center">-->
                <!--                    <template slot-scope="scope">-->
                <!--                        <span>{{timestampToTime(scope.row.createTime)}}</span>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->
                <el-table-column
                        :label="this.$t('title.Payee_address')"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.toAddress}}</span>
                        <br>
                        <span>{{to_32_decimal(scope.row.toAddress)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                         :label="this.$t('title.Amount_before_payment')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.toBeforeCoins}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Amount_after_receipt')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.toAfterCoins}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                         :label="this.$t('title.amount')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.coins}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                         :label="this.$t('title.Gas_fee')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.gasFee}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="hash"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.hash}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('title.time')"
                        width="250"

                        align="center">
                    <template slot-scope="scope">
                        <span>{{timestampToTime(scope.row.createTime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        :label="$t('title.state')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.status==-1? $t('title.Sent_awaiting_verification') :scope.row.status==-1? $t('title.failure') : $t('title.success') }}</span>
                    </template>
                </el-table-column>

            </el-table>
        </div>
    </div>

</template>

<script>
    import {
        getrpcserver,
        getchaininfo,
        createSig,
        getaccount,
        sendTxSig,
        userlList,
        usercontract,
        transferList,
        SignTransaction
    } from '../../../api/interface'
    import jsonView from '../../json-view/index.vue';
    import BigNumber from "bignumber.js"

    var abi = require('ethereumjs-abi');

    export default {
        name: 'SigTransfer',
        components: {jsonView},
        data() {
            return {
                sendValue: '',
                selectSigType: '1',
                createSigType: [
                    {type: '1', label: '普通交易sig'},
                    {type: '2', label: '合约交易sig'}
                ],
                selectContract: '',
                contractList: [],
                textarea: '',
                tableData: [],
                currentPage: 1,
                pagesize: 10,
                total: 0,
                isResponse: false,
                selectRpc: "",
                seleArr: [],
                optionRpc: [],
                selectChain: '',
                optionsChain: [],
                inputValue: '',
                searchValue: '',
                userA: [],
                userB: [],
                selectUserA: '',
                selectUserB: '',
                fullscreenLoading: false,

                json: {},
                theme: '',
                fontSize: 14,
                lineHeight: 24,
                deep: 3,
                iconStyle: 'square',
                closed: false,
                color1: '',
                color2: '',
            }
        },
        methods: {
            createSigs() {
                if (this.selectUserA == '' || this.selectUserB == '') {
                    this.$message.error('请正确选择From、To后，进行生成sig操作')
                } else if (this.sendValue=='') {
                    this.$message.error('请输入交易数额后，进行生成sig操作')
                } else {
                    let aa = ''
                    let bb = ''
                    let privateKey = ''

                    this.seleArr.forEach((item, index, self) => {
                        if (item.id == this.selectUserA) {
                            aa = item.address;
                            privateKey = '0x' + item.privateKey
                        }
                        if (item.id == this.selectUserB) {
                            bb = item.address
                        }
                    })
                    if (aa.toLowerCase() == bb.toLowerCase()) {
                        this.$message.error('请输入正确的转账地址')
                        return;
                    }
                    this.isResponse = true
                    let data = {
                        "rpcServer": this.selectRpc,
                        "chainId": this.selectChain,
                        "address": aa,
                    }
                    getaccount(data).then(response => {
                        if (this.selectSigType == '1') {
                            let nums = this.sendValue.trim();
                            let valueNum = new BigNumber(`${nums}`).multipliedBy('1e+18')
                            let obj = {
                                chainId: this.selectChain.toString(),
                                fromChainId: this.selectChain.toString(),
                                toChainId: this.selectChain.toString(),
                                from: aa.toLowerCase(),
                                to: bb.toLowerCase(),
                                nonce: response.data.nonce.toString(),
                                value: valueNum.toString(10),
                                input: ''
                            }
                            let signParams = SignTransaction(obj, privateKey);
                            this.json = signParams
                            this.isResponse = false
                        } else if (this.selectSigType == '2') {
                            let nums = this.sendValue.trim();
                            let encoded = abi.simpleEncode("transfer(address,uint256):(uint256,uint256)", bb.toLowerCase(), Number(nums));
                            let obj = {
                                chainId: this.selectChain.toString(),
                                fromChainId: this.selectChain.toString(),
                                toChainId: this.selectChain.toString(),
                                from: aa.toLowerCase(),
                                to: this.selectContract.toLowerCase(),
                                nonce: response.data.nonce.toString(),
                                value: '0',
                                input: encoded.toString('hex')
                            }
                            let signParams = SignTransaction(obj, privateKey);
                            this.json = signParams
                            this.isResponse = false
                        }
                    })
                    // createSig(data).then(response => {
                    //     this.isResponse = false

                    //     if (response.code == 200) {
                    //         // this.textarea=response.data
                    //         this.json = response.data.data
                    //     } else {
                    //         // this.textarea=''
                    //         this.json = {}
                    //     }
                    // })
                }
            },

            sendMsg() {
                // this.json = this.textarea
                // console.log(this.json)
                if (this.json.chainId) {
                    let data = {
                        "rpcServer": this.selectRpc,
                        "chainId": this.selectChain,
                        "tx": this.json

                    }
                    this.isResponse = true
                    sendTxSig(data).then(response => {
                        if (response.code == 200) {
                            let data1 = {
                                "type": "102",
                                "page": 1,
                                "rows": 10
                            }
                            this.isResponse = false

                            this.$message.success('交易成功！')
                            transferList(data1).then(response => {
                                if (response.code == 200) {
                                    this.tableData = response.data.data
                                } else {
                                    this.tableData = []
                                }
                            })
                        } else {
                            this.$message.error(response.msg)
                        }

                    })
                } else {
                    this.$message.error('请先生成sig后在进行该操作！')
                }


            },
            changeRpc() {
                this.fullscreenLoading = true
                let data = {rpcServer: this.selectRpc}
                getchaininfo(data).then(response => {
                    this.optionsChain = response.data
                    this.selectChain = this.optionsChain[0]
                    let data = {
                        "rpcServer": this.selectRpc,
                        "chainId": this.selectChain,
                        "address": "",
                        "page": 1,
                        "rows": 10000
                    }
                    userlList(data).then(response => {
                        this.fullscreenLoading = false
                        this.selectUserA = ''
                        this.selectUserB = ''
                        if (response.code == 200) {
                            this.seleArr = response.data.data
                            this.userA = response.data.data
                            this.userB = response.data.data
                        } else {
                            this.userA = []
                            this.userB = []
                            this.$message.error(response.msg)
                        }

                    })
                })
            },
            changeChain() {
                this.fullscreenLoading = true
                let data = {
                    "rpcServer": this.selectRpc,
                    "chainId": this.selectChain,
                    "address": "",
                    "page": 1,
                    "rows": 10000
                }
                userlList(data).then(response => {
                    this.fullscreenLoading = false
                    this.selectUserA = ''
                    this.selectUserB = ''
                    if (response.code == 200) {
                        this.seleArr = response.data.data
                        this.userA = response.data.data
                        this.userB = response.data.data
                    } else {
                        this.userA = []
                        this.userB = []
                        this.$message.error(response.msg)
                    }

                })
            },
            changeContract() {

            },
            changeSigType(item) {
                if (this.selectSigType == '2') {
                    usercontract().then(response => {
                        this.contractList = response.data.filter((item) => item.contractAddress);
                        this.selectContract = this.contractList[0].contractAddress
                    })
                }
            },
            changeUserA() {

            },
            changeUserB() {

            },
            getData() {
                getrpcserver().then(response => {
                    this.optionRpc = response.data
                    this.selectRpc = this.optionRpc[0].rpcUrl
                    let data = {rpcServer: this.optionRpc[0].rpcUrl}
                    getchaininfo(data).then(response => {
                        this.optionsChain = response.data
                        this.selectChain = this.optionsChain[0]
                        let data = {
                            "rpcServer": this.selectRpc,
                            "chainId": this.selectChain,
                            "address": "",
                            "page": 1,
                            "rows": 10000
                        }
                        userlList(data).then(response => {
                            if (response.code == 200) {
                                this.seleArr = response.data.data
                                this.userA = response.data.data
                                this.userB = response.data.data
                            } else {
                                this.userA = []
                                this.userB = []
                                this.$message.error(response.msg)
                            }

                        })
                    })
                })
            },
        },
        computed: {
            iconColor() {
                const {color1, color2} = this;

                if (color1 && color2) {
                    return [color1, color2];
                } else {
                    return [];
                }
            }
        },
        created() {
            this.getData()
        }

    }
</script>
<style scoped lang="less">
    #app {
        .layout {
            /*width: 1200px;*/
            /*margin: 0 auto;*/

            h1 {
                font-size: 26px;
                font-weight: 400;
                margin: 12px 0;
            }

            a {
                display: block;
                background-color: #f8f8f9;
                border-radius: 4px;
                padding: 8px 16px;
                border: 1px solid #edeff0;
                border-radius: 4px;
                margin-bottom: 20px;
                text-decoration: none;
                color: #2d8cf0;
            }

            .setting {
                border: 1px solid #ccc;
                padding: 10px 20px;

                h3 {
                    line-height: 1.6;
                    font-size: 18px;
                    color: #333;
                }
            }

            ul {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                align-items: center;

                li {
                    display: flex;
                    align-items: center;
                    padding: 10px 0;
                    padding-right: 20px;

                    label {
                        font-size: 13px;
                        padding-right: 10px;
                        color: #333;
                    }

                    select {
                        display: block;
                        width: 80px;
                        height: 28px;
                        background: #fff;
                    }
                }
            }


        }

        .content {
            border: 1px solid #ccc;
            border-top: none;
            max-height: 300px;
            overflow: auto;
            /*.content-wrap {*/
            /*   display: none !important;*/
            /*   background-color: rebeccapurple;*/
            /*}*/
        }
    }
</style>
<style scoped>
    .user_all {
        padding: 20px 30px;
        height: 100%;
    }

    .user_search {
        margin-bottom: 30px;
    }
</style>
